import {
  ThemeUICSSObject,
  getColorsAndStatesByPath,
  focusOutline,
  spacing,
} from '@apia/theme';

const list: ThemeUICSSObject = {
  overflow: 'auto',
  boxShadow: 'sharp',
  borderRadius: 'default',

  '.tabListItem[class]': {
    borderBottom: '1px solid',
    borderBottomColor: 'palette.border.field',

    width: '100%',
    display: 'flex ',
    alignItems: 'stretch',
    justifyContent: 'start',
    px: 4,
    py: 1,
    gap: spacing(4),
    '.label': {
      variant: 'inherit',
      flex: '10 0',
      textAlign: 'left',
    },
    'button.tabCheckbox': {
      ...getColorsAndStatesByPath('buttons.outline'),
    },

    ...getColorsAndStatesByPath('buttons.tab'),

    'button:not(.tabCheckbox)': {
      background: 'transparent',
    },
  },

  '.checkbox[class]': {
    height: '42px',
  },

  '& .tabListItem:focus-within': focusOutline,

  '& *:focus': {
    outline: 'none',
  },

  '& > .docsMarked .button__content': {
    color: '#DD0000',
  },

  button: {
    '&[role="checkbox"]': {
      marginTop: 2,
    },

    '&.tabLabel': {
      width: '100%',
      textAlign: 'left',
      display: 'flex',
      justifyContent: 'left',
    },

    img: {
      width: '15px',
      marginRight: 3,
    },
  },
};

export default list;
